import { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import arrayUtilities from '../../utilities/arrayUtilities';
import stringHelpers from '../../utilities/stringHelpers';
const groupSitesByClient = (sites) => {
    return sites.reduce((groups, site) => {
        if (!groups[site.clientId]) {
            groups[site.clientId] = [];
        }
        groups[site.clientId].push(site);
        return groups;
    }, {});
};
function WardenDashboard(props) {
    const [searchQuery, setSearchQuery] = useState("");

    const filteredSitesByClient = useMemo(() => {
        if (arrayUtilities.isNullOrEmpty(props.sites)) return {};

        const query = searchQuery.toLowerCase();    
        const sites = stringHelpers.isNullOrEmpty(searchQuery)
            ? props.sites
            : props.sites.filter(site =>
                site.name.toLowerCase().includes(query) ||
                site.clientName.toLowerCase().includes(query)
            );

        return groupSitesByClient(sites);
    }, [searchQuery, props.sites]);

    return (
        <div className='container-fluid'>
            <div className="row flex-center min-vh-50 py-6">
                <div className="col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4">
                    <div className="card">
                        <div className="card-header px-3 bg-light">
                            <h5 className="mb-0">Select a site</h5>
                        </div>
                        <div className="card-body py-3 px-3">

                            <div className="input-group">
                                <input
                                    className="form-control"
                                    value={ searchQuery }
                                    type="text"
                                    placeholder="search..."
                                    onChange={ (event) => setSearchQuery(event.target.value) }
                                />
                                <div className="input-group-append">
                                    <button
                                        style={ { height: "34px" } }
                                        className="btn btn-falcon-default btn-sm py-0"
                                        onClick={ () => setSearchQuery("") }>
                                        <i className="fas fa-times"></i> Clear
                                    </button>
                                </div>
                            </div>
                            <div className='mt-3'>
                                {
                                    filteredSitesByClient
                                    && Object.entries(filteredSitesByClient).map(([clientId, clientSites], index) =>
                                        <div key={clientId}>
                                            {index > 0 && <hr className="border-dashed border-bottom-0"></hr>}
                                            <h5 className="fs-1 mt-1 text-left">{clientSites[0].clientName}</h5>
                                            {
                                                clientSites.map(
                                                    site => <Link className="btn btn-link btn-block d-flex justify-content-between align-items-center py-0 mt-3 px-0" key={ site.id } to={ '/site/' + site.id }>
                                                        <span className='pl-3'>{ site.name }</span>
                                                        <span className="fas fa-chevron-right fs--2 ml-1"></span>
                                                    </Link>
                                                )
                                            }
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}
export default WardenDashboard;